
import React, { useEffect, useState } from 'react';
import '../assets/css/home.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';
import joinUseImg from '../assets/Images/joinUsImg.png';
import HappyClient from './HappyClient';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import API_BASE_URL from "../../helper";
function Home() {

  const texts = [
    "You can fly high like an eagle with us...",
    "Our passion in Web Development...",
    "Our passion in Android App Development...",
    "Our passion in IOS App Development..."
  ];

  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);       // Which line
  const [charIndex, setCharIndex] = useState(0); // Which letter

  useEffect(() => {
    const currentText = texts[index];

    // Typing effect
    if (charIndex < currentText.length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + currentText[charIndex]);
        setCharIndex(charIndex + 1);
      }, 100); // typing speed

      return () => clearTimeout(timeout);
    }

    // When line typing completed → wait 1.5 sec → next line
    const nextLineTimeout = setTimeout(() => {
      setText("");
      setCharIndex(0);
      setIndex((prev) => (prev + 1) % texts.length);
    }, 1500);

    return () => clearTimeout(nextLineTimeout);
  }, [charIndex, index]);

    

    // Fetch All Works
    const [works, setWorks] = useState([]);
    const fetchAllWorks = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/work/all`);
        const data = await response.json();
        setWorks(data);
      } catch (error) {
        console.error("Failed to load Works", error);
      }
    };

    useEffect(() => {
      fetchAllWorks();
    }, []);


    const [services, setSevices] = useState([]);

    // Fetch All Works
    const fetchAllservices = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/service/all`);
        const data = await response.json();
        setSevices(data);
      } catch (error) {
        console.error("Failed to load Services", error);
      }
    };  

    useEffect(() => {
      fetchAllservices();
    }, []);

  return (
    <div>
        <div id="hero-section" className="d-flex justify-content-center align-items-center flex-column"
        style={{background: `url(${bgImage}) center/cover no-repeat`}}>
          <h2 className="text-uppercase hero-title">Ezio Infotech</h2>
          {/* <p className='hero-subheading'>Our passion in Web Development</p> */}
          {/* <p className="hero-subheading"> {texts[index]} </p> */}
          <p className="hero-subheading">
            {text}
            <span className="cursor">|</span>
          </p>
      </div>

        <section id='joinWithUs' className='mt-5'>
          <div className='container joinWithUs'>
            <div className='row textDiv'>
              <div className='text col-md-6 mb-2'>
                <div>
                  <p className='fw-bold p-0 m-0 colorOne'>WEL COME EZIO INFOTECH</p>
                  <h2 className='text-upercase'>Let's Joint with us</h2>
                  <p className=''>At Ezio Infotech, we develop innovative and creative software and application that provide total client Satisfaction and information solutions.We belive on quality of work. <strong>Ezio Infotech Pvt Ltd</strong> is a global IT solutions company established in <strong>Jan 2022</strong>.</p>
                  <p className=''>We provide improved software and web application development with completely customizable solutions to create your website. We make it our business to first completely understand your approach and vision towards your products, your customers, your business processes and then bring a comprehensive and innovative e commerce solution customized to your business requirements at inexpensive rates.</p>
                  <a href='/contact' className='btn bg-primary text-white fw-bold'>Join Now</a>
                </div>
              </div>
              <div className='image col-md-6 mb-2'>
                <img className='img-fluid h-100' src={joinUseImg} alt='loading...' />
              </div>
            </div>
          </div>
        </section>

        <section id='clientProjectCounter' className='mt-5'>
          <div class="container">
            <div className='row'>
              <div className='col-md-6'>
                <div class="row">
                    <div class="col-md-4 mb-2">
                        <div class="counterTextDiv p-3 text-center"> 
                          <h2><i class="fa-solid fa-business-time"></i></h2>
                          <h4 class="fw-bold">4</h4>
                          <h4 class="fw-bold text-uppercase">Years of Experience</h4>
                        </div>
                    </div>
                    <div class="col-md-4 mb-2">
                        <div class="counterTextDiv p-3 text-center"> 
                          <h2><i class="fa-solid fa-users"></i></h2>
                          <h4 class="fw-bold">15</h4>
                          <h4 class="fw-bold text-uppercase">Happy Customers</h4>
                        </div>
                    </div>
                    <div class="col-md-4 mb-2">
                        <div class="counterTextDiv p-3 text-center"> 
                          <h2><i class="fas fa-project-diagram"></i></h2>
                          <h4 class="fw-bold">30</h4>
                          <h4 class="fw-bold text-uppercase">Total Project</h4>
                        </div>
                    </div>
                </div>
              </div>
              <div className='col-md-6 mb-2'>
                <div className='row'>
                  <div className='col-md-6 mb-2'>
                    <div className='bg-two p-3 h-100'>
                      <h3 className='text-center text-uppercase'>Vision</h3>
                      <p>Our Mission is to achieve our goal by providing distinguished software services in the global markets by constant Innovation in Technology and our business opportunities.</p>
                    </div>
                  </div>
                  <div className='col-md-6  mb-2'>
                    <div className='bg-two p-3 h-100'>
                      <h3 className='text-center text-uppercase'>Mission</h3>
                      <p>Providing all type of effective software solutions to all kind of organization with the latest technology adopted Constant improvement and to be a leading performer in the adopted services. Making user friendly & customizable application to get the desired output. Getting the Valued customers and keep continuing serving them.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        <section id='work' className='mt-5'>
          <div className='container'>
            <div className='row justify-content-center mb-4'>
              <div className='col-md-8'>
                <h2 className='text-center'>How We Works</h2>
                <p className='text-center'>
                  We are a leading Mobile App and Web Development Company, and we offer highly interactive software that leads you in getting more customers, ease in management activities, and more profits. Our team with excellent knowledge of technologies brings your ideas to life. We give our best, push technology, and reach the last boundaries to get perfection.
                </p>
              </div>
            </div>

            <div className='row'>
              {works.length > 0 ? (
                works.map((work) => (
                  <div className='col-md-4 mb-4' key={work.id}>
                    <div className='workDiv'>
                      <div className='text-center mb-2'>
                        <img
                          className='workImg'
                          src={`${API_BASE_URL}/assets/Images/${work.image}`}
                          alt="loading"
                        />
                      </div>
                      <div className='text-center'>
                        <h5 className='text-uppercase'>{work.name}</h5>
                        <p>{work.description}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No Works Available</p>
              )}
            </div>

          </div>
        </section>

        <section id='services' className='mt-5'>
          <div className='container'>
            <div className='row justify-content-center mb-4'>
              <div className='col-md-8'>
                <h2 className='text-center'>Our Best Services</h2>
                <p className='text-center'>We specialize in providing customized software development services for startups, small to mid-size and enterprise size businesses..</p>
              </div>
            </div>

              <div className='row'> 
                {services.length > 0 ? (
                services.map((service) => (
                  <div className='col-md-4 mb-4' key={service.id}>
                    <div className='serviceDiv'>
                      <div className='text-center mb-2'>
                        <img className='workImg' src={`${API_BASE_URL}/assets/Images/${service.image}`} alt="loading" />
                      </div>
                      <div className='text-center'>
                        <h5 className='text-uppercase'>{service.name}</h5>
                        <p>{service.description}</p>
                      </div>
                    </div>
                  </div> 
                ))
              ) : (
                <p>No Services Available</p>
              )} 
            </div>

          </div>
        </section>


        <HappyClient />


    </div>
  )  
}

export default Home;
